import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import '../styles/Login.css';

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated } = useAuth();
  
  // Redirect to home if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Get the page the user was trying to access
  const from = location.state?.from?.pathname || '/';

  const handleEnter = () => {
    // Automatically log in the user (you might want to pass a default value or remove password check)
    login("garden123"); // Or login('default') depending on your AuthContext implementation
    
    // Navigate to the page they were trying to access
    navigate(from, { replace: true });
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Welcome! </h1>
        <p>Your journey to a greener world begins now.</p>
        
        <button onClick={handleEnter} className="login-button">
          Enter the Garden
        </button>
      </div>
    </div>
  );
}

export default Login;